import { Pin } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import { addImageSizing } from '@lessonup/utils';
import React from 'react';
import { usePinThemeContext } from '../../utils/pinTheme/PinThemeContext';

export interface PinBackgroundProps {
  pinType: Pin['type'];
  settings: Pin['settings'];
  isThumb?: boolean;
}

export const PinBackground: React.FC<PinBackgroundProps> = ({ pinType, settings, isThumb }) => {
  const { getPinSettings } = usePinThemeContext();
  const pinSettings = getPinSettings(pinType, settings);
  const imageUrl =
    pinSettings.backgroundImage && addImageSizing({ url: pinSettings.backgroundImage, isThumb: isThumb, size: 'xl' });

  return (
    <PinBackgroundWrapper style={{ backgroundColor: pinSettings.backgroundColor }}>
      {pinSettings.backgroundImage && (
        <PinBackgroundImageContainer
          style={{
            backgroundImage: `url(${imageUrl})`,
            opacity: `${pinSettings.backgroundTransparency}%`,
          }}
        />
      )}
    </PinBackgroundWrapper>
  );
};

const PinBackgroundImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background: no-repeat;
  background-size: cover;
`;

const PinBackgroundWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
`;
